import Dinero from 'dinero.js';
import dayjs from 'dayjs';
import { ExpectedDelay } from './ExpectedDelay';
var Variant = /** @class */ (function () {
    function Variant() {
    }
    Variant.prototype.toApi = function () {
        var _a, _b;
        // make sure to null-check if some fields are optional.
        var dtoScheduleDate = dayjs(this.scheduleDate).isValid() ? dayjs(this.scheduleDate).toISOString() : null;
        return Object.assign({}, this, {
            price: (_a = this.price) === null || _a === void 0 ? void 0 : _a.getAmount(),
            scheduleDate: dtoScheduleDate,
            expectedDelay: (_b = this.expectedDelay) === null || _b === void 0 ? void 0 : _b.toApi(),
        });
    };
    Variant.createFromApi = function (dto) {
        // make sure to null-check if some fields are optional.
        var scheduleDateObject = dto.scheduleDate ? dayjs(dto.scheduleDate).toDate() : null;
        var price = null;
        if (dto.price !== null && dto.price !== undefined) {
            price = Dinero({ amount: Math.round(dto.price * 100), currency: 'USD' });
        }
        return Object.assign(new Variant(), dto, {
            price: price,
            scheduleDate: scheduleDateObject,
            expectedDelay: ExpectedDelay.createFromApi(dto.expectedDelay),
        });
    };
    Variant.IsPurchaseable = function (variant) {
        switch (variant === null || variant === void 0 ? void 0 : variant.priceType) {
            case "FreeToReadAndPurchaseble":
            case "FreeToReadForRegisteredAndPurchaseble":
            case "Paid":
                return true;
            default:
                return false;
        }
    };
    Variant.IsReadable = function (variant) {
        switch (variant === null || variant === void 0 ? void 0 : variant.priceType) {
            case "FreeToReadAndPurchaseble":
            case "FreeToReadForRegisteredAndPurchaseble":
            case "Free":
            case "FreeForRegistered":
                return true;
            default:
                return false;
        }
    };
    return Variant;
}());
export { Variant };
